// lib/api/social-auth.ts

// Get the base API URL from environment
const getApiUrl = () => {
  return process.env.NEXT_PUBLIC_API_URL || 'https://dev-api.laxferries.com';
};

// Google OAuth authentication - direct navigation
export const googleAuth = () => {
  const apiUrl = getApiUrl();
  const authUrl = `${apiUrl}/user/auth/google`;
  
  // Navigate directly to OAuth URL
  window.location.href = authUrl;
};

// Apple OAuth authentication - direct navigation
export const appleAuth = () => {
  const apiUrl = getApiUrl();
  const authUrl = `${apiUrl}/user/auth/apple`;
  
  // Navigate directly to OAuth URL
  window.location.href = authUrl;
};

// Facebook OAuth authentication - direct navigation
export const facebookAuth = () => {
  const apiUrl = getApiUrl();
  const authUrl = `${apiUrl}/user/auth/facebook`;
  
  // Navigate directly to OAuth URL
  window.location.href = authUrl;
};